
const styleHelper = {
  /**
   * Returns a css object with translate values
   * @param {Number} x - The x translate position
   * @param {Number} y- The y translate position
   * @param {Number} z - The z translate position
   * @param {Boolean} css3dsupported - If css 3d
   * transforms should be used
   * @returns {Object} A style object
   */
  getTranslateStyle(x, y, z, css3dsupported) {
    const xPos = x || 0;
    const yPos = y || 0;
    const zPos = z || 0;
    let positionTransformString = 'translate(' + xPos + 'px,' + yPos + 'px)';

    if (css3dsupported) {
      positionTransformString = 'translate3d(' + xPos + 'px ,' + yPos + 'px, ' + zPos + 'px)';
    }

    return this.getTransformStyle(positionTransformString);
  },


  /**
   * Returns a css object with translate values
   * @param {Number} degree - The rotation degree
   * transforms should be used
   * @returns {Object} A style object
   */
  getRotateStyle(degree) {
    const positionTransformString = 'rotate(' + degree + 'deg)';

    return this.getTransformStyle(positionTransformString);
  },


  /**
   * Returns a css object with translate and rotate values
   * @param {Number} x - The x translate position
   * @param {Number} y- The y translate position
   * @param {Number} z - The z translate position
   * @param {Number} degree - The rotation degree
   * transforms should be used
   * @param {Boolean} css3dsupported - If css 3d
   * transforms should be used
   * @returns {Object} A style object
   */
  getTranslateAndRotateStyle(x, y, z, degree, css3dsupported) {
    const xPos = x || 0;
    const yPos = y || 0;
    const zPos = z || 0;

    let fullTransformString = '';
    const rotationTransformString = 'rotate(' + degree + 'deg)';
    let positionTransformString = 'translate(' + xPos + 'px,' + yPos + 'px)';

    if (css3dsupported) {
      positionTransformString = 'translate3d(' + xPos + 'px ,' + yPos + 'px, ' + zPos + 'px)';
    }

    fullTransformString = rotationTransformString + ' ' + positionTransformString;

    return this.getTransformStyle(fullTransformString);
  },


  /**
   * Returns a css object with transform values
   * @param {String} styleString - A string of css transform values
   * @returns {Object} A style object
   */
  getTransformStyle(styleString) {
    return {
      msTransform: styleString,
      WebkitTransform: styleString,
      MozTransform: styleString,
      transform: styleString,
    };
  },


  /**
   * Returns a css object with transsition duration values
   * @param {String} transitionDuration - The transitionDuration style
   * @returns {Object} A style object
   */
  getTransitionDurationStyle(transitionDuration) {
    return {
      msTransitionDuration: transitionDuration,
      WebkitTransitionDuration: transitionDuration,
      MozTransitionDuration: transitionDuration,
      transitionDuration,
    };
  },


  /**
   * Returns a size object to fit an element to a container element
   * (simulates css background-size: cover)
   * @param {Number} objectWidth - The width of the element to size
   * @param {Number} objectHeight - The height of the element to size
   * @param {Number} containerWidth - The width of the container
   * @param {Number} containerHeight - The height of the container
   * @returns {Object} A size object
   */
  getSizeToCover(objectWidth, objectHeight, containerWidth, containerHeight) {
    const horizontalScale = containerWidth / objectWidth;
    const verticalScale = containerHeight / objectHeight;
    const scale = horizontalScale > verticalScale ? horizontalScale : verticalScale;
    const width = scale * objectWidth;
    const height = scale * objectHeight;
    const marginLeft = (containerWidth / 2) - (width / 2);
    const marginTop = (containerHeight / 2) - (height / 2);

    return {
      width,
      height,
      marginLeft,
      marginTop,
    };
  },
};

export default styleHelper;



/** WEBPACK FOOTER **
 ** ./assets/js/src/helpers/style.js
 **/